import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'bcac-select',
  templateUrl: './bcac-select.component.html',
  styleUrls: ['./bcac-select.component.scss']
})
export class BcacSelectComponent implements OnInit {

  constructor() { }

  value: string | number = '';

  dataList: { value: string, label: string }[]
  ngOnInit() {
  }
  // 当前选中的值
  @Input()
  set bcacModel(model: string | number) {
    this.value = model;
  };
  // 当前列表的值
  @Input()
  set bcacList(list: { value: string, label: string }[]) {
    this.dataList = list;
  }

  @Output()
  bcacModelChange: EventEmitter<any> = new EventEmitter();

  ngModelChange($event) {
    this.bcacModelChange.emit($event);
  }
  size: 'small' | 'default' | 'large' = 'small';
  @Input()
  set bcacSize(size: 'small' | 'default' | 'large') {
    this.size = size;
  }
}
